import React from 'react';

import Row from '@amzn/meridian/row';
import SearchField from '@amzn/meridian/search-field';
import Text from '@amzn/meridian/text';

interface ICommentSearchProps {
    searchQuery: string;
    onSearchChange: (query: string) => void;
    placeholder?: string;
    showResultCount?: boolean;
    filteredCount?: number;
    totalCount?: number;
    title?: string;
}

export const CommentSearch = ({
    searchQuery,
    onSearchChange,
    placeholder = 'Search comments...',
    showResultCount = true,
    filteredCount = 0,
    totalCount = 0,
    title = 'comments'
}: ICommentSearchProps) => {
    return (
        <>
            <SearchField
                value={searchQuery}
                onChange={onSearchChange}
                placeholder={placeholder}
                onSubmit={() => {}}
                searchButton={true}
                clearButton={true}
            />

            {/* Show filter results count when filtering */}
            {showResultCount && searchQuery.trim() && (
                <Row spacingInset="300 0 300 0">
                    <Text type="b200" color="secondary">
                        Showing {filteredCount} of {totalCount} {title}
                    </Text>
                </Row>
            )}
        </>
    );
};
